var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"demo-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h2',[_vm._v("Conversations 会话列表")])]),_c('BasicUsageDemo'),_c('GroupStickyDemo'),_c('CustomGroupSortDemo'),_c('BuiltInMenuDemo'),_c('CustomMenuDemo'),_c('LoadMoreDemo'),_c('CustomStyleDemo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }